"use strict";
import React, {Component} from "react";
import {PropTypes, RenderContent} from "Subschema";
import debounce from "lodash/function/debounce";

export default class Bank extends Component {

    static template = false;

    static propTypes = {
        "processor": PropTypes.processor,
        "style": PropTypes.style,
        "transition": PropTypes.transition,
        "accountNumber": PropTypes.value,
        "routingNumber": PropTypes.value,
        "onError": PropTypes.errorEvent,
        "onChange": PropTypes.valueEvent,
        "disclosure": PropTypes.content,
        "reminder": PropTypes.content,
        "errorMsg": PropTypes.content,
        "error": PropTypes.error,
        "url": PropTypes.expression
    };

    static injectedProps = {
        "processor": "BankProcessor",
        "style": "Bank",
        "transition": "rollUp",
        "accountNumber": "..accountNumber",
        "routingNumber": "..routingNumber",
        "url": "/api/getBankName.json"
    };

    constructor(props) {
        super(props);
        this.checkStatus = debounce((accountNumber, routingNumber) => {
            if (!this.mounted) return;

            if (('' + accountNumber).trim().length >= 3 && ('' + routingNumber).trim().length > 4) {
                this.props.processor.fetch(this.props.url, {accountNumber, routingNumber}, this.handleResponse);
            } else {
                setTimeout(() => {
                    this.props.onChange(null);
                }, 0);
            }
        }, 1500, {leading: false, trailing: true});
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillReceiveProps(props) {
        if (this.props.accountNumber !== props.accountNumber ||
            this.props.routingNumber !== props.routingNumber) {
            this.checkStatus(props.accountNumber, props.routingNumber);
        }
    }

    handleResponse = (e, o) => {
        if (e || !o || !o.name) {
            this.props.onChange(null);
            this.props.onError({message: this.props.errorMsg });
            return;
        }
        if (o && o.name) {
            this.props.onChange(o.name);
            this.props.onError(null);
        }
    };

    renderError = () => {
        const { errorMsg, errorClass } = this.props;
        return errorMsg ? <RenderContent content={errorMsg} className={errorClass}/> : null;
    };

    renderBank = () => {
        const {style, value, disclosure, reminder, accountNumber, nameClass, reminderClass, disclosureClass, routingNumber, transition, containerStyle} = this.props;
        return <div key='has-bank' className={`${containerStyle} ${style[value]}`}>
            <h3 className={nameClass}>{value}</h3>
            {disclosure ? <RenderContent content={disclosure} className={disclosureClass}/> : null}
            {reminder ? <RenderContent content={reminder} className={reminderClass}/> : null}
        </div>
    };

    render() {
        const {style, value, accountNumber, routingNumber, transition, containerStyle, error} = this.props;
        const {Transition, ...tprops} = transition;

        return <Transition {...tprops}>{value ? this.renderBank() : error ? this.renderError() : <span key="no-bank"/>}</Transition>
    }
}



/** WEBPACK FOOTER **
 ** ./src/types/bank/Bank.jsx
 **/